import React, { useEffect, useState } from 'react'
import "./Calculator.scss";
import TextField from '@material-ui/core/TextField';

const InformationQuota = (props) => {

    const selectItem = (item) => {
        props.country_change(item)
        props.handleDisplayModal(!props.displayModal)
    }
    return (
        <div className="container">

            <TextField
                label="Quotation reference"
                id="outlined-size-normal"
                variant="outlined"
                style={{ width: "100%" }}
                value={props.customer_name}
                onChange={(e) => props.customer_name_change(e.target.value)}
            />


            <fieldset className="my-fieldset" style={{ marginTop: "20px" }} onClick={() => props.handleDisplayModal(!props.displayModal)}>
                <legend className="my-legend-country-information-quota">
                    Country
                </legend>

                <div className="d-flex justify-content-between" style={{ marginBottom: "20px", marginTop: "10px" }}>
                    <span style={{ marginLeft: "10px" }}>{props.country}</span>
                    <div style={{ marginRight: "10px" }}>
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.184424 11.8192C-0.0391203 11.6001 -0.0594426 11.2571 0.123458 11.0155L0.184424 10.9462L5.23006 6L0.184424 1.05377C-0.0391203 0.83462 -0.0594426 0.491687 0.123458 0.250032L0.184424 0.180798C0.407969 -0.0383512 0.75778 -0.0582738 1.00428 0.12103L1.0749 0.180798L6.56558 5.56351C6.78912 5.78266 6.80944 6.1256 6.62654 6.36725L6.56558 6.43649L1.0749 11.8192C0.829005 12.0603 0.430324 12.0603 0.184424 11.8192Z" fill="#200E32" />
                        </svg>
                    </div>

                </div>
            </fieldset>
            <span style={{
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: "14px",
                lineHeight: "17px",
                color: "#898989"
            }}>Currency is changed by country</span>

            <div className={`Modal ${props.displayModal ? "Show" : ""}`}>
                <div style={{ marginTop: "10px" }}>
                    <h3>Country</h3>
                </div>

                <button
                    className="Close"
                    onClick={() => props.handleDisplayModal(!props.displayModal)}
                >
                    X
                </button>
                <hr />

                {props.datacountrya.length > 0 ? props.datacountrya.map((item, key) => {
                    return (
                        <div key={key} className="container" onClick={() => selectItem(item)}>
                            <p>{item.name}</p>
                            <hr />

                        </div>
                    )
                }) : "No data"}
            </div>
            <div
                className={`Overlay ${props.displayModal ? "Show" : ""}`}
                onClick={() => props.handleDisplayModal(!props.displayModal)}
            />
        </div>

    )
}

export default InformationQuota
